/* eslint-disable no-console */
import firebase from 'firebase/app'
import 'firebase/firebase-firestore'
import * as constants from '../../../constants.json'
import * as util from '../../util'
import remDiacritics from 'remove-accents'

export default {
  /**
     * Properties from the app state.
     * @property {array} state.loadedCategories   - Array of category objects fetched from database.
     * @property {object} state.loadedCategory    - Category object fetched from database.
     * @property {object} state.relationshipsMap  - The categories relationships map fetched from database.
     * @property {object} state.categoriesNames   - The category names fetched from database.
     */
  state: {
    loadedCategories: [],
    loadedCategory: {},
    relationshipsMap: {},
    categoriesNames: {}
  },

  mutations: {

    /**
         * Mutation method that add a new category object to `state.loadedCategories`.
         * @param {object} state    - The state property.
         * @param {object} payload  - The category object.
         */
    mutationAddNewCategory (state, payload) {
      state.loadedCategories.push(payload)
    },

    /**
         * Mutation method that load all categories fetched from database to `state.loadedCategories`.
         * @param {object} state    - The state property.
         * @param {array} payload   - Array of category objects.
         */
    mutationSetLoadedCategories (state, payload) {
      state.loadedCategories = payload
    },

    /**
         * Mutation method that load a single product object to `state.loadedProduct`.
         * @param {object} state    - The state property.
         * @param {object} payload  - The product object.
         */
    mutationLoadSingleCategory (state, payload) {
      state.loadedCategory = payload
    },

    /**
         * Mutation method tha delete a category object from `state.loadedCategories`.
         * @param {object} state    - The state property.
         * @param {string} payload  - The category object Id.
         */
    mutationDeleteLoadedCategory (state, payload) {
      let index = 0

      for (let el of state.loadedCategories) {
        if (el.categoryId === payload) {
          state.loadedCategories.splice(index, 1)
          break
        }
        index++
      }
    },

    /**
         * Mutation method that load the relationshp map between categories to `state.relationshipsMap`.
         * @param {object} state    - The state property.
         * @param {object} payload  - The relationship map loaded from firestore.
         */
    mutationSetRelationshipsMap (state, payload) {
      state.relationshipsMap = payload
    },

    /**
         * Mutation method that load the category names to `state.categoriesNames`.
         * @param {object} state    - The state property.
         * @param {object} payload  - The category names loaded from firestore.
         */
    mutationSetCategoriesNames (state, payload) {
      state.categoriesNames = payload
    }
  },

  actions: {

    /**
         * Adding category content to database
         * @param {object} - Contains all the category data
         */
    async actionCreateUpdateCategory ({ commit }, payload) {
      // Loading on
      commit('mutationSetLoading', true)
      console.log('actionCreateUpdateCategory - payload: ', payload)

      let dataRef
      try {
        // Get a new write batch
        const batch = firebase.firestore().batch()
        if (payload.categoryId) {
          /**
           * Updating keywords and categories arrays in all categories doc
           * If parentId or categoryName have been changed, we update the "keywords" field in all categories and products docs containing the former parentId.
           */
          console.log('Updating keywords and categories arrays in all categories doc')

          // Get relationship map from firestore
          const relationshipsMapDoc = await firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories_relationships')
            .get()

          let relationshipsMap
          if (!relationshipsMapDoc.empty) {
            relationshipsMap = relationshipsMapDoc.docs[0].data()

            console.log('relationshipsMap', relationshipsMap)
          }

          // Updating "categories" and "keywords" fields in categories docs
          // Get all categories that contains the catgoryId to be deleted within its categories array.
          const categoriesRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories')

          const categoriesQuery = categoriesRef.where('categories', 'array-contains', payload.categoryId)
          const categoriesResult = await categoriesQuery.get()

          console.log('categoriesResult', categoriesResult)

          // Updating categories and keywords arrays from all the categories containing the category id to be changed
          if (!categoriesResult.empty) {
            for (let doc of categoriesResult.docs) {
              console.log('doc.data()', doc.data())
              let categories = doc.data().categories

              // Transforming keywords maps into an array.
              let keywords = []

              for (let keyword in doc.data().keywords) {
                keywords.push(keyword)
              }

              // Deleting keywords and category ids if the user has changed the parent category.
              if (payload.categoryChanged) {
                console.log('The category has changed')

                if (payload.formerParentId !== null && payload.formerParentId !== 'none') {
                  if (keywords.indexOf(relationshipsMap.categories_names[payload.formerParentId].toLowerCase()) !== -1) {
                    keywords.splice(keywords.indexOf(relationshipsMap.categories_names[payload.formerParentId].toLowerCase()), 1)
                  }
                  categories.splice(categories.indexOf(payload.formerParentId), 1)

                  util.deleteCategoriesAndKeywords(
                    relationshipsMap.categoriesId_parentsId,
                    relationshipsMap.categories_names,
                    payload.formerParentId,
                    keywords,
                    categories)
                }

                console.log('categories', categories)

                console.log('keywords', keywords)

                // Adding the new category tree to "keywords" and "categories" arrays.
                if (payload.newParentId !== 'none') {
                  categories.push(payload.newParentId)
                  keywords.push(relationshipsMap.categories_names[payload.newParentId].toLowerCase())
                  util.addCategoryToKeyword(relationshipsMap.categoriesId_parentsId,
                    relationshipsMap.categories_names,
                    payload.newParentId,
                    keywords,
                    categories)
                }

                console.log('this.categories', categories)

                console.log('this.keywords', keywords)
              }

              if (keywords.indexOf(relationshipsMap.categories_names[payload.categoryId].toLowerCase()) !== -1) {
                keywords.splice(keywords.indexOf(relationshipsMap.categories_names[payload.categoryId].toLowerCase()), 1)
              }
              keywords.push(payload.categoryName.toLowerCase())

              // Transforming keywords array into a map.
              const keywordsObj = {}

              for (let keyword of keywords) {
                keywordsObj[keyword] = true
              }

              // Updating parent category name
              const parentCategory = { ...doc.data().parentCategory }
              parentCategory.name = payload.categoryName

              // Updating database.
              batch.update(categoriesRef.doc(doc.id), { categories: categories, keywords: keywordsObj })
            }
          }

          // Updating categories and keywords arrays from all products related to the category id to be changed.
          const productsRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('products')

          const productsQuery = productsRef.where('categories', 'array-contains', payload.categoryId)
          const productsResult = await productsQuery.get()

          console.log('productsResult: ', productsResult)

          if (!productsResult.empty) {
            console.log('There are products related to this category')

            for (let product of productsResult.docs) {
              console.log('product.data()', product.data())
              let categories = product.data().categories

              // Get index
              const indexRef = firebase
                .firestore()
                .collection('companies')
                .doc(payload.companyId)
                .collection('bots')
                .doc(constants.BOT_ID)
                .collection('index')

              let prodIndexId = product.data().productName.slice(0, 2)
              prodIndexId = remDiacritics(prodIndexId.toLowerCase())
              const prodIndexDoc = await indexRef.doc(prodIndexId).get()
              const prodIndexArray = prodIndexDoc.data().index

              // Transforming keywords maps into an array.
              let oldKeywords = []
              let newKeywords = []
              const deletedKeywords = []

              for (let keyword in product.data().keywords) {
                oldKeywords.push(keyword)
                newKeywords.push(keyword)
              }

              // Deleting keywords and category ids if the user has changed the parent category.

              console.log('oldKeywords', [...oldKeywords])
              console.log('categories', [...categories])
              console.log(payload.formerParentId)

              if (payload.categoryChanged) {
                console.log('category changed')

                // Deleted keywords related to the former parent category
                if (payload.formerParentId !== null && payload.formerParentId !== 'none') {
                  console.log('Deleted keywords related to the former parent category')

                  if (oldKeywords.indexOf(relationshipsMap.categories_names[payload.formerParentId].toLowerCase()) !== -1) {
                    newKeywords.splice(oldKeywords.indexOf(relationshipsMap.categories_names[payload.formerParentId].toLowerCase()), 1)
                  }
                  categories.splice(categories.indexOf(payload.formerParentId), 1)

                  console.log('newKeywords', [...newKeywords])

                  // Deleting all keywords and categories ids from categories ancestors.
                  util.deleteCategoriesAndKeywords(
                    relationshipsMap.categoriesId_parentsId,
                    relationshipsMap.categories_names,
                    payload.formerParentId,
                    newKeywords,
                    categories
                  )

                  // Get deleted keywords
                  oldKeywords.forEach(oldKword => {
                    console.log('oldKword: ', oldKword)
                    console.log('newKeywords.findIndex(oldKword): ', newKeywords.indexOf(oldKword))
                    if (newKeywords.indexOf(oldKword) === -1) {
                      deletedKeywords.push(oldKword)
                    }
                  })
                }

                console.log('newKeywords', [...newKeywords])
                console.log('deletedKeywords', [...deletedKeywords])

                // Adding the new category tree in "keywords" and "categories" arrays
                if (payload.newParentId !== 'none') {
                  console.log('New parent Id')

                  categories.push(payload.newParentId)

                  newKeywords.push(relationshipsMap.categories_names[payload.newParentId].toLowerCase())

                  util.addCategoryToKeyword(
                    relationshipsMap.categoriesId_parentsId,
                    relationshipsMap.categories_names,
                    payload.newParentId,
                    newKeywords,
                    categories)
                }
                console.log('newKeywords', [...newKeywords])
              }

              console.log('categoryName', relationshipsMap.categories_names[payload.categoryId].toLowerCase())

              if (newKeywords.indexOf(relationshipsMap.categories_names[payload.categoryId].toLowerCase()) !== -1) {
                newKeywords.splice(newKeywords.indexOf(relationshipsMap.categories_names[payload.categoryId].toLowerCase()), 1)
              }
              newKeywords.push(payload.categoryName.toLowerCase())

              console.log('categories', [...categories])

              console.log('newKeywords', [...newKeywords])

              // Transforming newKeywords array into a map
              const keywordsObj = {}

              for (const keyword of newKeywords) {
                keywordsObj[keyword] = true
              }

              // Updating parent category name
              const parentCategories = [...product.data().parentCategories]
              parentCategories.forEach((el, index) => {
                if (el.id === payload.categoryId) {
                  parentCategories[index].name = payload.categoryName
                }
              })

              console.log('keywordsObj: ', keywordsObj)

              // Updating product doc
              batch.update(productsRef.doc(product.id), { categories, keywords: keywordsObj, parentCategories })

              // Updating variations keywords
              // Get variations
              const variationsDocs = await productsRef
                .where('type', '==', 'variation')
                .where('productId', '==', product.id)
                .orderBy('name')
                .get()

              const variationsKeywords = []
              if (!variationsDocs.empty) {
                // Deleting keywords related to former parent categories

                variationsDocs.forEach(variation => {
                  // Adding the keywords that not belong to the deleted keywords
                  let varKeywords = {}

                  for (const varKeyword in variation.data().keywords) {
                    if (deletedKeywords.indexOf(varKeyword) === -1) { // Variation's keyword doesn't exist in deleted keywords
                      varKeywords[varKeyword] = true
                    }
                  }

                  variationsKeywords.push({
                    newVarKwords: { ...varKeywords },
                    id: variation.id
                  })
                })
                console.log('variationsKeywords: ', [...variationsKeywords])

                // Adding new keywords to variations
                variationsKeywords.forEach(el => {
                  // Transforming newVarKeywords into an array
                  const varKwords = []
                  for (const kword in el.newVarKwords) {
                    varKwords.push(kword)
                  }

                  // Adding new keywords
                  for (const newKword of newKeywords) {
                    if (varKwords.indexOf(newKword) === -1) {
                      el.newVarKwords[newKword] = true
                    }
                  }
                })
                console.log('variationsKeywords: ', [...variationsKeywords])

                variationsKeywords.forEach(el => {
                  batch.update(productsRef.doc(el.id), { keywords: el.newVarKwords })
                })
              }

              // Updating keywords from product index

              prodIndexArray[prodIndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

              variationsKeywords.forEach(variation => {
                // Transforming newVarKeywords into an array
                const varKwords = []
                for (const kword in variation.newVarKwords) {
                  varKwords.push(kword)
                }

                prodIndexArray[prodIndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
              })

              console.log('prodIndexArray: ', prodIndexArray)
              batch.update(indexRef.doc(prodIndexId), { index: prodIndexArray })

              // Updating keywords from alterName1 index
              if (product.data().alterName1 !== '') {
                console.log('Updating keywords from alterName1 index')
                let alterName1IndexId = product.data().alterName1.slice(0, 2)
                alterName1IndexId = remDiacritics(alterName1IndexId.toLowerCase())

                const alterName1IndexDoc = await indexRef.doc(alterName1IndexId).get()
                const alterName1IndexArray = alterName1IndexDoc.data().index

                alterName1IndexArray[alterName1IndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

                variationsKeywords.forEach(variation => {
                  // Transforming newVarKeywords into an array
                  const varKwords = []
                  for (const kword in variation.newVarKwords) {
                    varKwords.push(kword)
                  }

                  alterName1IndexArray[alterName1IndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
                })

                console.log('alterName1IndexArray: ', alterName1IndexArray)
                batch.update(indexRef.doc(alterName1IndexId), { index: alterName1IndexArray })
              }

              // Updating keywords from alterName2 index
              if (product.data().alterName2 !== '') {
                console.log('Updating keywords from alterName2 index')
                let alterName2IndexId = product.data().alterName2.slice(0, 2)
                alterName2IndexId = remDiacritics(alterName2IndexId.toLowerCase())

                const alterName2IndexDoc = await indexRef.doc(alterName2IndexId).get()
                const alterName2IndexArray = alterName2IndexDoc.data().index

                alterName2IndexArray[alterName2IndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

                variationsKeywords.forEach(variation => {
                  // Transforming newVarKeywords into an array
                  const varKwords = []
                  for (const kword in variation.newVarKwords) {
                    varKwords.push(kword)
                  }

                  alterName2IndexArray[alterName2IndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
                })

                console.log('alterName2IndexArray: ', alterName2IndexArray)
                batch.update(indexRef.doc(alterName2IndexId), { index: alterName2IndexArray })
              }
            }
          }

          // Updating categories counter in bot doc
          console.log('Updating categories counter in bot doc')
          // Get bot document
          const botRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)

          // Increase value
          let increase = firebase.firestore.FieldValue.increment(1)

          // Decrement value
          let decrease = firebase.firestore.FieldValue.increment(-1)

          /**
           * CC = category changed; SC = status changed; S = status; A = answer
           * T = true; F = false; P = published; O = other
           *
           *        CC    SC    S    A
           *        T     T     P    new parentId increase
           *        T     T     O    foremer parentId decrease
           *        T     F     P    former decrease; new increase
           *        T     F     O    nothing
           *        F     T     P    actual parentId increase
           *        F     T     O    actual parentId decrease
           *        F     F     P    nothing
           *        F     F     O    nothing
           */

          // Update counter

          // Category Changed = True
          if (payload.categoryChanged) {
            console.log('Category Changed = True')
            // Status Changed = True
            if (payload.statusChanged) {
              console.log('Status Changed = True')
              // Status = Published
              if (payload.status === 'published') {
                console.log('Status = Published')
                if (payload.newParentId === 'none') {
                  console.log('payload.newParentId = none')
                  batch.set(botRef, { categories: { parents: increase } }, { merge: true })
                } else {
                  console.log('payload.newParentId != none')
                  batch.set(botRef, { categories: { [payload.newParentId]: increase } }, { merge: true })
                }
              // Status != Published
              } else {
                console.log('Status != Published')
                if (payload.formerParentId === 'none') {
                  console.log('payload.formerParentId = none')
                  batch.set(botRef, { categories: { parents: decrease } }, { merge: true })
                } else if (payload.formerParentId !== null) {
                  console.log('payload.formerParentId != null')
                  batch.set(botRef, { categories: { [payload.formerParentId]: decrease } }, { merge: true })
                }
              }
            // Status Changed = False && Status = Published
            } else if (payload.status === 'published') {
              console.log('Status Changed = False && Status = Published')
              if (payload.formerParentId === 'none') {
                console.log('payload.formerParentId = none')
                batch.set(botRef, { categories: { parents: decrease } }, { merge: true })
                batch.set(botRef, { categories: { [payload.newParentId]: increase } }, { merge: true })
              } else if (payload.formerParentId !== null) {
                console.log('payload.formerParentId != null')
                batch.set(botRef, { categories: { [payload.formerParentId]: decrease } }, { merge: true })
                if (payload.newParentId === 'none') {
                  console.log('payload.newParentId = none')
                  batch.set(botRef, { categories: { parents: increase } }, { merge: true })
                } else {
                  console.log('payload.newParentId != none')
                  batch.set(botRef, { categories: { [payload.newParentId]: increase } }, { merge: true })
                }
              } else {
                console.log('Status Changed = False && Status != Published')
                if (payload.newParentId === 'none') {
                  console.log('payload.newParentId = none')
                  batch.set(botRef, { categories: { parents: increase } }, { merge: true })
                } else {
                  console.log('payload.newParentId != none')
                  batch.set(botRef, { categories: { [payload.newParentId]: increase } }, { merge: true })
                }
              }
            }
          // Category Changed = False
          } else {
            console.log('Category Changed = False')
            // Status Changed = True
            if (payload.statusChanged) {
              console.log('Status Changed = True')
              // Status = Published
              if (payload.status === 'published') {
                console.log('Status = Published')
                if (payload.parentId === 'none') {
                  console.log('payload.parentId = none')
                  batch.set(botRef, { categories: { parents: increase } }, { merge: true })
                } else if (payload.parentId !== null) {
                  console.log('payload.parentId = null')
                  batch.set(botRef, { categories: { [payload.parentId]: increase } }, { merge: true })
                }
              // Status != Published
              } else {
                console.log('Status != Published')
                if (payload.parentId === 'none') {
                  console.log('payload.parentId = none')
                  batch.set(botRef, { categories: { parents: decrease } }, { merge: true })
                } else if (payload.parentId !== null) {
                  console.log('payload.parentId = null')
                  batch.set(botRef, { categories: { [payload.parentId]: decrease } }, { merge: true })
                }
              }
            }
          }

          /**
           * Updating relationshipsMap in categories_relationship doc.
           */
          console.log('Updating relationshipsMap in categories_relationship doc.')

          // Set new relationship map to firestore.
          const realtionshipsRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories_relationships')
            .doc('1')

          batch.set(realtionshipsRef, { categoriesId_parentsId: { [payload.relationshipCategoryId]: payload.relationshipParentId } }, { merge: true })
        }

        /**
         * Creating or updating the category
         */
        console.log('Creating or updating the category.')
        // Auxiliar object to update the state via mutation
        payload.keywords = payload.keywords.map(keyword => remDiacritics(keyword.toLowerCase()))
        const contentToState = { ...payload }

        // Auxiliar object to store the data in firestore
        const contentToFirestore = {
          categoryName: payload.categoryName,
          status: payload.status,
          shortDescription: payload.shortDescription,
          longDescription: payload.shortDescription,
          imageUrl: payload.imageUrl,
          videoUrl: payload.videoUrl,
          gallery: [...payload.gallery],
          categories: payload.categories,
          keywords: {},
          parentCategory: payload.parentCategory,
          creationDate: payload.creationDate,
          id: ''
        }

        // Transforming keywords array into maps to store them in firestore
        payload.keywords.forEach(keyword => {
          contentToFirestore.keywords[keyword] = true
        })

        console.log('contentToState: ', contentToState)

        console.log('contentToFirestore: ', contentToFirestore)

        // // Loading flowComponents data to auxiliar object in order to store the flow data in firestore
        // const flowToFirestore = { flow: [] }
        // flowToFirestore.flow = [...payload.flowComponents]

        // let keyName
        if (payload.categoryId) {
          console.log('category exits, payload.productId: ', payload.categoryId)

          // Category doc reference
          dataRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories')
            .doc(payload.categoryId)
        } else {
          // If product doc does not exist we run a batch write and increase the category counter.

          console.log('category does not exist')
          dataRef = firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories')
            .doc()
        }

        // -------Storing data on firebase-------

        // Set the contentToFirestore values to write batch in firestore.

        console.log('Storing categories data to firestore')
        contentToFirestore.id = dataRef.id
        contentToState.categoryId = dataRef.id
        batch.set(dataRef, contentToFirestore)

        // // Set the flowToFirestore values
        // batch.set(dataRef.collection('flows').doc('1'), flowToFirestore)

        // console.log('flowToFirestore data stored')

        // Storing category name in categories_relationships doc.
        if (payload.categoryId) {
          batch.set(firebase
            .firestore()
            .collection('companies')
            .doc(payload.companyId)
            .collection('bots')
            .doc(constants.BOT_ID)
            .collection('categories_relationships')
            .doc('1'),
          { categories_names: { [payload.categoryId]: payload.categoryName } }, { merge: true }
          )
        }

        // Committing batch write
        await batch.commit()

        console.log('data stored on firebase: ', contentToState)

        // Mutating state
        commit('mutationAddNewCategory', contentToState)

        // Loading off
        commit('mutationSetLoading', false)

        console.log('loading: ', this.getters.getLoading)

        return contentToState
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
         * Loading all categories from database
         * @param {object} - Contains companyId
         */
    async actionLoadCategories ({ commit }, payload) {
      const categories = []

      console.log('Loading categories')

      console.log('companyId', payload.companyId)

      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Get all products from firestore
        const dataRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories')
        const queryCategories = await dataRef.orderBy('categoryName').get()

        console.log('queryCategories', queryCategories)

        // Load categories to the state
        queryCategories.docs.forEach(async category => {
          categories.push({
            categoryName: category.data().categoryName,
            status: category.data().status,
            shortDescription: category.data().shortDescription,
            imageUrl: category.data().imageUrl,
            // flowComponents: [],
            categories: category.data().categories,
            parentCategory: category.data().parentCategory,
            creationDate: category.data().creationDate,
            modificationDate: category.data().modificationDate,
            categoryId: category.id
          })
        })

        console.log('categories', categories)
        commit('mutationSetLoadedCategories', categories)

        // Activate new toolbar
        commit('mutationSetNewToolbar', true)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
         * Loading single category data
         * @param {object} payload -Contains companyId and categoryId
         */
    async actionLoadSingleCategory ({ commit }, payload) {
      console.log('Loading single category')

      console.log('payload', payload)

      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Get category doc from firebase
        const dataRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories')
          .doc(payload.categoryId)
        const queryCategory = await dataRef.get()

        // Load auxiliar object with the category data
        const categoryObj = {
          categoryName: queryCategory.data().categoryName,
          status: queryCategory.data().status,
          shortDescription: queryCategory.data().shortDescription,
          longDescription: queryCategory.data().longDescription,
          imageUrl: queryCategory.data().imageUrl,
          videoUrl: queryCategory.data().videoUrl,
          gallery: [],
          // flowComponents: [],
          categories: queryCategory.data().categories,
          keywords: [],
          parentCategory: queryCategory.data().parentCategory,
          creationDate: queryCategory.data().creationDate,
          modificationDate: queryCategory.data().modificationDate,
          categoryId: queryCategory.id
        }
        // Transforming keywords maps into an array

        for (let key in queryCategory.data().keywords) {
          categoryObj.keywords.push(key)
        }

        // Loading gallery's data
        const gallery = []
        queryCategory.data().gallery.forEach(el => {
          gallery.push({
            image: '',
            imageUrl: el.imageUrl,
            title: el.title,
            subtitle: el.subtitle
          })
        })

        // // Loading flow's data
        // const flows = []
        // const queryFlows = await dataRef.collection('flows').doc('1').get()

        // console.log('queryFlows', queryFlows.data())
        // queryFlows.data().flow.forEach((el1, index1) => {
        //   flows.push({
        //     selectContentType: el1.selectContentType,
        //     description: el1.description,
        //     image: '',
        //     video: '',
        //     gallery: [],
        //     keywords: el1.keywords,
        //     imageUrl: el1.imageUrl,
        //     videoUrl: el1.videoUrl,
        //     title: el1.title,
        //     showOnWeb: el1.showOnWeb
        //   })
        //   if (el1.selectContentType === 'Galería') {
        //     el1.gallery.forEach(el2 => {
        //       flows[index1].gallery.push({
        //         image: '',
        //         imageUrl: el2.imageUrl,
        //         title: el2.title,
        //         subtitle: el2.subtitle
        //       })
        //     })
        //   }
        // })

        // Loading all categories data to state
        categoryObj.gallery = gallery
        // categoryObj.flowComponents = flows

        console.log('categoryObj', categoryObj)
        commit('mutationLoadSingleCategory', categoryObj)

        // Activating new toolbar
        commit('mutationSetNewToolbar', true)

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    },

    /**
       * Delete category and update realtionships.
       *
       * @param {object} payload - Contains companyId and categoryId.
       */
    async actionDeleteCategory ({ commit }, payload) {
      console.log('Deleting category')

      console.log('payload', payload)
      try {
        // Get category docs containing to be changed
        const categoriesRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories')
        const res = await categoriesRef.doc(payload.categoryId).get()

        // -----Updating the category's counter in bot doc.-----
        const batch = firebase.firestore().batch()

        const botRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)

        const botDoc = await botRef.get()
        const categoryCounter = { ...botDoc.data().categories }
        const categories = {}

        // Copy all the keys from categoryCounter but the key to be deleted

        if (res.data().status === 'published') {
          for (const keyName in categoryCounter) {
            if (keyName !== payload.categoryId) {
              categories[keyName] = categoryCounter[keyName]
            }
          }
          console.log('categoryCounter', categories)
          batch.update(botRef, { categories })
          // Update counter.
          //          Decreasing value.
          const decrease = firebase.firestore.FieldValue.increment(-1)
          if (res.data().parentCategory.id === 'none') {
            batch.set(botRef, { categories: { parents: decrease } }, { merge: true })
          } else if (res.data().parentCategory.id !== null) {
            batch.set(botRef, { categories: { [res.data().parentCategory.id]: decrease } }, { merge: true })
          }
          //          Increasing value.
          if (categoryCounter[payload.categoryId]) {
            const increase = firebase.firestore.FieldValue.increment(categoryCounter[payload.categoryId])
            if (res.data().parentCategory.id === 'none') {
              batch.set(botRef, { categories: { parents: increase } }, { merge: true })
            } else if (res.data().parentCategory.id !== null) {
              batch.set(botRef, { categories: { [res.data().parentCategory.id]: increase } }, { merge: true })
            }
          }
        }

        // Delete category from database and update the state.
        batch.delete(categoriesRef.doc(payload.categoryId))
        commit('mutationDeleteLoadedCategory', payload.categoryId)

        // ---- Deleting category id and names from categories docs containing the category id to be changed----
        const queryDoc = await firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories_relationships')
          .get()
        const categoriesRelationships = queryDoc.docs[0].data()

        const categoriesQuery = categoriesRef.where('categories', 'array-contains', payload.categoryId)
        const categoriesResult = await categoriesQuery.get()

        console.log('categoriesResult', categoriesResult)

        if (!categoriesResult.empty) {
          for (let doc of categoriesResult.docs) {
            console.log('doc.data()', doc.data())
            let categories = doc.data().categories

            // Transforming keyword map into an array.
            let keywords = []

            for (let keyword in doc.data().keywords) {
              keywords.push(keyword)
            }
            let parentCategory = doc.data().parentCategory

            // Deleting Keyword.
            if (keywords.length !== 0) {
              keywords.splice(keywords.indexOf(categoriesRelationships.categories_names[payload.categoryId]), 1)
            }
            // Deleting categoryId.
            categories.splice(categories.indexOf(payload.categoryId), 1)

            // Updating parentCategory.
            if (parentCategory.id === payload.categoryId) {
              if (categoriesRelationships.categoriesId_parentsId[payload.categoryId] === 'none') {
                parentCategory.id = 'none'
                parentCategory.name = 'none'
              } else {
                parentCategory.id = categoriesRelationships.categoriesId_parentsId[payload.categoryId]
                parentCategory.name = categoriesRelationships.categories_names[parentCategory.id]
              }
            }

            // Transforming keywords array into a map
            const keywordsObj = {}

            for (let keyword of keywords) {
              keywordsObj[keyword] = true
            }

            // Updating database
            batch.update(categoriesRef.doc(doc.id), { categories: categories, keywords: keywordsObj, parentCategory: parentCategory })
          }
        }

        // --- Deleting category id and name from products docs containing the category id to be changed----
        const productsRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('products')

        const productsQuery = productsRef.where('categories', 'array-contains', payload.categoryId)
        const productsResult = await productsQuery.get()

        console.log('productsResult', productsResult)

        if (!productsResult.empty) {
          for (let product of productsResult.docs) {
            console.log('product.data()', product.data())
            let categories = product.data().categories
            const newKeywords = []
            const oldKeywords = []
            const deletedKeywords = []

            // Transforming keyword map into an array

            for (let keyword in product.data().keywords) {
              newKeywords.push(keyword)
              oldKeywords.push(keyword)
            }

            console.log('oldKeywords: ', [...oldKeywords])

            // Deleting keywords
            if (newKeywords.length !== 0) {
              if (newKeywords.indexOf(categoriesRelationships.categories_names[payload.categoryId]) !== -1) {
                newKeywords.splice(newKeywords.indexOf(categoriesRelationships.categories_names[payload.categoryId]), 1)
              }
            }

            console.log('newKeywords: ', [...newKeywords])

            // Get deleted keywords
            oldKeywords.forEach(oldKword => {
              if (newKeywords.indexOf(oldKword) === -1) {
                deletedKeywords.push(oldKword)
              }
            })

            // Deleting categoryId
            categories.splice(categories.indexOf(payload.categoryId), 1)

            // Updating variations keywords
            // Get variations
            const variationsDocs = await productsRef
              .where('type', '==', 'variation')
              .where('productId', '==', product.id)
              .orderBy('name')
              .get()

            const variationsKeywords = []

            if (!variationsDocs.empty) {
              // Deleting keywords related to former parent categories

              variationsDocs.forEach(variation => {
                // Adding the keywords that not belong to the deleted keywords
                let varKeywords = {}

                for (const varKeyword in variation.data().keywords) {
                  if (deletedKeywords.indexOf(varKeyword) === -1) { // Variation's keyword doesn't exist in deleted keywords
                    varKeywords[varKeyword] = true
                  }
                }

                variationsKeywords.push({
                  newVarKwords: { ...varKeywords },
                  id: variation.id
                })
              })
              console.log('variationsKeywords: ', [...variationsKeywords])

              variationsKeywords.forEach(el => {
                batch.update(productsRef.doc(el.id), { keywords: el.newVarKwords })
              })
            }

            // Updating keywords from product index
            const indexRef = firebase
              .firestore()
              .collection('companies')
              .doc(payload.companyId)
              .collection('bots')
              .doc(constants.BOT_ID)
              .collection('index')

            let prodIndexId = product.data().productName.slice(0, 2)
            prodIndexId = remDiacritics(prodIndexId.toLowerCase())
            const prodIndexDoc = await indexRef.doc(prodIndexId).get()
            const prodIndexArray = prodIndexDoc.data().index

            prodIndexArray[prodIndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

            variationsKeywords.forEach(variation => {
              // Transforming newVarKeywords into an array
              const varKwords = []
              for (const kword in variation.newVarKwords) {
                varKwords.push(kword)
              }

              prodIndexArray[prodIndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
            })

            console.log('prodIndexArray: ', prodIndexArray)
            batch.update(indexRef.doc(prodIndexId), { index: prodIndexArray })

            // Updating keywords from alterName1 index
            if (product.data().alterName1 !== '') {
              let alterName1IndexId = product.data().alterName1.slice(0, 2)
              alterName1IndexId = remDiacritics(alterName1IndexId.toLowerCase())

              const alterName1IndexDoc = await indexRef.doc(alterName1IndexId).get()
              const alterName1IndexArray = alterName1IndexDoc.data().index

              alterName1IndexArray[alterName1IndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

              variationsKeywords.forEach(variation => {
                // Transforming newVarKeywords into an array
                const varKwords = []
                for (const kword in variation.newVarKwords) {
                  varKwords.push(kword)
                }

                alterName1IndexArray[alterName1IndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
              })

              console.log('alterName1IndexArray: ', alterName1IndexArray)
              batch.update(indexRef.doc(alterName1IndexId), { index: alterName1IndexArray })
            }

            if (product.data().alterName2 !== '') {
              let alterName2IndexId = product.data().alterName2.slice(0, 2)
              alterName2IndexId = remDiacritics(alterName2IndexId.toLowerCase())

              const alterName2IndexDoc = await indexRef.doc(alterName2IndexId).get()
              const alterName2IndexArray = alterName2IndexDoc.data().index

              alterName2IndexArray[alterName2IndexArray.findIndex(el => el.id === product.id)].keywords = newKeywords

              variationsKeywords.forEach(variation => {
                // Transforming newVarKeywords into an array
                const varKwords = []
                for (const kword in variation.newVarKwords) {
                  varKwords.push(kword)
                }

                alterName2IndexArray[alterName2IndexArray.findIndex(el => el.id === variation.id)].keywords = varKwords
              })

              console.log('alterName2IndexArray: ', alterName2IndexArray)
              batch.update(indexRef.doc(alterName2IndexId), { index: alterName2IndexArray })
            }

            // --------- Updating parentCategory and product counter---------

            const productCounter = { ...botDoc.data().products }
            const products = {}

            // Copy all the keys from productCounter but the key to be deleted

            for (const keyName in productCounter) {
              if (keyName !== payload.categoryId) {
                products[keyName] = productCounter[keyName]
              }
            }
            batch.update(botRef, { products })

            // Increase product counter
            const increase = productCounter[payload.categoryId]

            // Search the category Id to be deleted
            let parentCategories = [...product.data().parentCategories]

            console.log('parentCategories', product.data().parentCategories)

            parentCategories.forEach((el, index) => {
              if (el.id === payload.categoryId) {
                if (index === 0) {
                  // If the first parent category is top level, we initialize it as empty string
                  if (categoriesRelationships.categoriesId_parentsId[el.id] === 'none') {
                    parentCategories[index].id = ''
                    parentCategories[index].name = ''
                  } else {
                    // Or replace the parent category with its own parent category
                    parentCategories[index].id = categoriesRelationships.categoriesId_parentsId[el.id]
                    parentCategories[index].name = categoriesRelationships.categories_names[parentCategories[index].id]

                    batch.set(botRef, { products: { [parentCategories[index].id]: increase } }, { merge: true })
                  }
                } else {
                  // Else we erase the element from the array
                  if (categoriesRelationships.categoriesId_parentsId[payload.categoryId] === 'none') {
                    parentCategories.splice(index, 1)
                  } else {
                    // Or replace the parent category with its own parent category
                    parentCategories[index].id = categoriesRelationships.categoriesId_parentsId[payload.categoryId]
                    parentCategories[index].name = categoriesRelationships.categories_names[parentCategories[index].id]

                    batch.set(botRef, { products: { [parentCategories[index].id]: increase } }, { merge: true })
                  }
                }
              }
            })

            // Transforming keywords array into a map
            const keywordsObj = {}

            for (let keyword of newKeywords) {
              keywordsObj[keyword] = true
            }
            // Updating database
            batch.update(productsRef.doc(product.id), { categories: categories, keywords: keywordsObj, parentCategories: parentCategories })
          }
        }

        // Deleting category from categories_relationships
        let relationshipsMap = {}
        let categoriesNames = {}

        console.log('categoriesRelationships', categoriesRelationships)

        for (let key in categoriesRelationships.categoriesId_parentsId) {
          console.log(`${key}: ${categoriesRelationships.categoriesId_parentsId[key]}`)
          if (key !== payload.categoryId) {
            if (categoriesRelationships.categoriesId_parentsId[key] === payload.categoryId) {
              relationshipsMap[key] = categoriesRelationships.categoriesId_parentsId[payload.categoryId]
            } else {
              relationshipsMap[key] = categoriesRelationships.categoriesId_parentsId[key]
            }
            categoriesNames[key] = categoriesRelationships.categories_names[key]
          }
        }

        console.log('relationshipsMap', relationshipsMap)

        console.log('categoriesNames', categoriesNames)

        // Set the new categories_relationships doc
        const relationshipsRef = firebase
          .firestore()
          .collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories_relationships')
          .doc('1')
        batch.set(relationshipsRef, { categoriesId_parentsId: relationshipsMap, categories_names: categoriesNames })

        // Committing all batch writes
        await batch.commit()

        console.log('category deleted')
      } catch (error) {
        throw error
      }
    },

    /**
     * Load relationshipsMap
     * @param {object} payload -Contains the fallowing porperties: companyId.
     */
    async actionsLoadRelationshipsMap ({ commit }, payload) {
      // Loading on
      commit('mutationSetLoading', true)
      try {
        // Get categories_relationships doc and load to the state
        const queryDoc = await firebase
          .firestore().collection('companies')
          .doc(payload.companyId)
          .collection('bots')
          .doc(constants.BOT_ID)
          .collection('categories_relationships')
          .get()

        if (queryDoc.empty) {
          commit('mutationSetRelationshipsMap', {})
          commit('mutationSetCategoriesNames', {})
        } else {
          const relationshipsMap = queryDoc.docs[0].data()

          console.log('relationshipsMap', relationshipsMap)
          commit('mutationSetRelationshipsMap', relationshipsMap.categoriesId_parentsId)
          commit('mutationSetCategoriesNames', relationshipsMap.categories_names)
        }

        // Loading off
        commit('mutationSetLoading', false)
      } catch (error) {
        commit('mutationSetLoading', false)
        throw error
      }
    }
  },

  getters: {
    /**
     * @returns the array of cateogories from the state.
     */
    getLoadedCategories (state) {
      return state.loadedCategories
    },

    /**
     * @returns all category data from the state.
     */
    getLoadedSingleCategory (state) {
      return state.loadedCategory
    },

    /**
     * @returns the relationships map
     */
    getRelationShipsMap (state) {
      return state.relationshipsMap
    },

    /**
     * @returns the categories names
     */
    getCategoriesNames (state) {
      return state.categoriesNames
    }
  }
}
// ToDo's
// Agregar notitificaciones en la vista de categorías y de productos cuando se hayan realizado cambios importantes
